import type { SiteConfig } from '../types';

/**
 * NNSA archive — brand palette from the live deployment
 * (theme/nnsa.less: @nnsa-color-main-1 #364272, secondary #507196).
 * DOE / NNSA agency branding removed; kept as a neutral archive skin.
 */
const nnsa: SiteConfig = {
  id: 'nnsa',
  pathPrefix: 'nnsa',
  baseUrl: 'https://archives.nnsa.doxcelerate.com',
  title: 'Policies & Directives',
  tagline: 'Archive of policies, delegations and charters',
  seoName: 'NNSA Policies & Directives Archive',
  seoDescription:
    'An independent archive of NNSA policies, supplemental ' +
    'directives, delegations and charters. Published by ' +
    'Doxcelerate Corporation — not affiliated with NNSA/DOE.',
  colors: {
    primary: '#364272',
    secondary: '#262f52',
    accent: '#e40101',
  },
  ga4: 'G-3DWXFC7MFY',
  nav: [
    { label: 'Home', to: '/' },
    { label: 'Documents', to: '/documents' },
    { label: 'Delegations', to: '/delegations' },
    { label: 'Search', to: '/search' },
    { label: 'About', to: '/about' },
    { label: 'Contact', to: '/contact' },
  ],
  disclaimer:
    'This is an independent archive operated by Doxcelerate Corporation. It is not affiliated with, endorsed by, or operated by the National Nuclear Security Administration or the U.S. Department of Energy. Documents are reproduced for reference; where this archive and the official NNSA site disagree, the official site is correct.',
  footerGroups: [
    {
      heading: 'Browse',
      links: [
        { label: 'All Documents', to: '/documents' },
        { label: 'Delegations', to: '/delegations' },
        { label: 'Search', to: '/search' },
      ],
    },
    {
      // Cross-links between the archives + the corporate site. These are
      // the only inbound links the sister archives have - keep them.
      heading: 'More from Doxcelerate',
      links: [
        { label: 'DOE Technical Standards Archive', to: 'https://archives.standards.doxcelerate.com/', external: true },
        { label: 'DOE Directives Archive', to: 'https://archives.directives.doxcelerate.com/', external: true },
        { label: 'Doxcelerate Corporation', to: 'https://www.doxcelerate.com/', external: true },
      ],
    },
  ],
  // Paste the token from each console here to verify this hostname.
  // null emits no tag; an empty string would emit a FAILED verification.
  verification: {
    google: null,
    bing: null,
  },
};

export default nnsa;
